import { Client, useClient } from 'urql'
import {
  Mutation_Root,
  Principle_Config,
  Principle_Config_Bool_Exp,
  Principle_Config_Set_Input,
  Subprinciple_Config,
  Subprinciple_Config_Bool_Exp,
  Subprinciple_Config_Set_Input,
} from 'src/@types/graphql'
import { updateSortOnPrincipleConfig } from 'src/screens/administration/configuration-management/principles-configuration/principles/principlesConfigQueries'
import { updateSortOnSubprincipleConfig } from 'src/screens/administration/configuration-management/principles-configuration/subprinciples/subprinciplesConfigQueries'

const switchPrinciplesPosition = (urqlClient: Client) => async (pc1: Principle_Config, pc2: Principle_Config) => {
  if (pc1.sort_number === pc2.sort_number) {
    return Promise.reject(new Error())
  }

  const setClausePrinciple1: Principle_Config_Set_Input = {
    sort_number: pc2.sort_number,
  }

  const setClausePrinciple2: Principle_Config_Set_Input = {
    sort_number: pc1.sort_number,
  }

  const updateFirstWhere: Principle_Config_Bool_Exp = { id: { _eq: pc1.id } }
  const updateSecondWhere: Principle_Config_Bool_Exp = { id: { _eq: pc2.id } }

  return urqlClient
    .mutation<
      {
        updateFirst: Mutation_Root['update_principle_config']
        updateSecond: Mutation_Root['update_principle_config']
      },
      {
        firstWhere: Principle_Config_Bool_Exp
        secondWhere: Principle_Config_Bool_Exp
        setClause1: Principle_Config_Set_Input
        setClause2: Principle_Config_Set_Input
      }
    >(updateSortOnPrincipleConfig, {
      firstWhere: updateFirstWhere,
      secondWhere: updateSecondWhere,
      setClause1: setClausePrinciple1,
      setClause2: setClausePrinciple2,
    })
    .toPromise()
}

const switchSubprinciplesPosition =
  (urqlClient: Client) => async (spc1: Subprinciple_Config, spc2: Subprinciple_Config) => {
    if (spc1.sort_number === spc2.sort_number) {
      return Promise.reject(new Error())
    }

    const setClauseSubprinciple1: Subprinciple_Config_Set_Input = {
      sort_number: spc2.sort_number,
    }

    const setClauseSubprinciple2: Subprinciple_Config_Set_Input = {
      sort_number: spc1.sort_number,
    }

    const principleId = spc1.principle_config_id

    const updateFirstWhere: Subprinciple_Config_Bool_Exp = {
      _and: [{ id: { _eq: spc1.id }, principle_config_id: { _eq: principleId } }],
    }

    const updateSecondWhere: Subprinciple_Config_Bool_Exp = {
      _and: [{ id: { _eq: spc2.id }, principle_config_id: { _eq: principleId } }],
    }

    return urqlClient
      .mutation<
        {
          updateFirst: Mutation_Root['update_subprinciple_config']
          updateSecond: Mutation_Root['update_subprinciple_config']
        },
        {
          firstWhere: Subprinciple_Config_Bool_Exp
          secondWhere: Subprinciple_Config_Bool_Exp
          setClause1: Subprinciple_Config_Set_Input
          setClause2: Subprinciple_Config_Set_Input
        }
      >(updateSortOnSubprincipleConfig, {
        firstWhere: updateFirstWhere,
        secondWhere: updateSecondWhere,
        setClause1: setClauseSubprinciple1,
        setClause2: setClauseSubprinciple2,
      })
      .toPromise()
  }

export const useSortPrinciples = () => {
  const urqlClient = useClient()
  return {
    switchPrinciplesPosition: switchPrinciplesPosition(urqlClient),
    switchSubprinciplesPosition: switchSubprinciplesPosition(urqlClient),
  }
}
